export default __webpack_public_path__ + "static/media/G0425.34I-22401_-17336_0-(1).1692956700000.e1d6eb2c.jpg";